// Generated by ReScript, PLEASE EDIT WITH CARE


var en_BD = "en";

var bn_BD = "bn-BD";

var en_AE = "en-AE";

var en_TR = "en-TR";

var tr_TR = "tr-TR";

var en_IN = "en-IN";

var en_MY = "en-MY";

var bdLocales = [
  en_BD,
  bn_BD
];

var aeLocales = [en_AE];

var trLocales = [
  en_TR,
  tr_TR
];

var indLocales = [en_IN];

var myLocales = [en_MY];

var en = "en";

var bn = "bn";

var tr = "tr";

var enInd = "in";

var en_TK = "en-TK";

var en_string = "English";

var bn_string = "Bangla";

var ae_string = "English";

var tr_string = "Turkish";

var my_string = "English";

var uae_default = en_AE;

var tr_default = tr_TR;

var bd_default = bn_BD;

var ind_default = en_IN;

var my_default = en_MY;

export {
  en ,
  bn ,
  tr ,
  enInd ,
  en_BD ,
  bn_BD ,
  en_AE ,
  en_TR ,
  tr_TR ,
  en_TK ,
  en_IN ,
  en_MY ,
  bdLocales ,
  aeLocales ,
  trLocales ,
  indLocales ,
  myLocales ,
  en_string ,
  bn_string ,
  ae_string ,
  tr_string ,
  my_string ,
  uae_default ,
  tr_default ,
  bd_default ,
  ind_default ,
  my_default ,
}
/* No side effect */
